import { api } from './_apiInterface';
import { pointer } from 'src/app-config';
import { typeBoardDoc, typeBoardItem, typeBoardItemType, typeBoardSection } from '@monorepo/models';

class BoardServices {
    private Base = pointer.board;
    //
    AddSection = async (title: string) => {
        const data = await api.SendRequest(this.Base, 'POST', { title });
        return data;
    }
    DeleteSection = async (section: typeBoardSection) => {
        const body = {
            section: {
                id: section.id,
                items: section.items,
                order: section.order,
                title: section.title
            }
        };
        const data = await api.SendRequest(this.Base, 'DELETE', body);
        return data;
    }
    EditSectionTitle = async (sectionId: number, sectionTitle: string, title: string) => {
        const data = await api.SendRequest(this.Base, 'PATCH', { sectionId, sectionTitle, title });
        return data;
    }
    Get = async () => {
        const data = await api.SendRequest<{ board: typeBoardDoc; }>(this.Base, 'GET');
        return data;
    }
    ReorderSections = async (sections: typeBoardSection[]) => {
        const body = {
            sections: sections.map(section => ({
                id: section.id,
                items: section.items,
                order: section.order,
                title: section.title
            }))
        };
        const data = await api.SendRequest(this.Base, 'PATCH', body);
        return data;
    }
    // ITEMS
    AddItem = async (sectionId: number, sectionTitle: string, itemType: typeBoardItemType, title: string | null, content: string | null, file: File | null) => {
        if (file) {
            return await api.SendRequestSendFile(`${this.Base}/item?sectionId=${sectionId}&sectionTitle=${sectionTitle}&itemType=${itemType}`, file);
        } else {
            return await api.SendRequest(`${this.Base}/item?sectionId=${sectionId}&sectionTitle=${sectionTitle}&itemType=${itemType}`, 'POST', { content, title });
        }
    }
    ArchiveFile = async (sectionId: number, sectionTitle: string, item: typeBoardItem, unarchive: boolean) => {
        const body = {
            item,
            sectionId,
            sectionTitle,
            unarchive
        };
        const data = await api.SendRequest(`${this.Base}/item`, 'PUT', body);
        return data;
    }
    DeleteItem = async (sectionId: number, sectionTitle: string, item: typeBoardItem) => {
        const body = {
            item,
            sectionId,
            sectionTitle
        };
        const data = await api.SendRequest(`${this.Base}/item`, 'DELETE', body);
        return data;
    }
    GetArchivedFile = async (sectionTitle: string, item: typeBoardItem, openingNewTab: boolean) => {
        const itemJson = JSON.stringify(item);
        const data = await api.SendRequestDownloadFile(`${this.Base}/item?sectionTitle=${sectionTitle}&item=${itemJson}&archived=true`, openingNewTab, item.originalName);
        return data;
    }
    GetPdfFile = async (sectionTitle: string, item: typeBoardItem) => {
        const itemJson = JSON.stringify(item);
        const data = await api.SendRequestDownloadFile<{ fileObjectUrl: string; }>(`${this.Base}/item?sectionTitle=${sectionTitle}&item=${itemJson}`, undefined, undefined, true);
        return data;
    }
    ReorderItems = async (sectionId: number, sectionTitle: string, items: typeBoardItem[]) => {
        const body = {
            items,
            sectionId,
            sectionTitle
        };
        const data = await api.SendRequest(`${this.Base}/item`, 'PATCH', body);
        return data;
    }
}

export const boardServices = new BoardServices();
